<template>
    <Modal :show="showModal" @close="hide">
        <h2 class="text-center text-2xl font-medium">{{ $t('Confirm your presence to the event') }} {{ event.title }}</h2>

        <div class="mt-12 flex justify-center">
            <img :src="event.banner" alt="" class="h-48 rounded-xl object-contain" />
        </div>

        <!-- Blocks the application feature if it is not in an accepted country -->
        <div class="mt-24" v-if="!canApply">
            <div class="flex justify-center">
                <div class="mx-auto flex h-24 w-24 flex-shrink-0 items-center justify-center rounded-full bg-red-100">
                    <svg
                        class="h-12 w-12 text-red-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        aria-hidden="true"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
                        />
                    </svg>
                </div>
            </div>

            <div class="flex justify-center">
                <div class="mt-3 text-center">
                    <h3 class="text-base font-semibold leading-6 text-gray-900" id="modal-title">{{ $t('Event unavailable') }}</h3>
                    <div class="mt-2">
                        <p class="text-sm text-gray-500">
                            {{
                                $t(
                                    'Sorry, but this event is not available in your country. We understand that this can be disappointing, but unfortunately we have to respect geographical restrictions imposed by the employer or local regulations.'
                                )
                            }}
                        </p>
                        <p class="mt-5 text-sm text-gray-500">
                            {{ $t('Thank you for your understanding and your interest in our website.') }}
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <InscriptionForm v-if="canApply" :model="event" :is-event="true" @success="onSuccess" />
    </Modal>
</template>

<script setup>
    import InscriptionForm from '@/Partials/InscriptionForm.vue';
    import Modal from '@/Shared/Modal.vue';
    import { trans } from 'laravel-vue-i18n';
    import Swal from 'sweetalert2';
    import { onMounted, ref } from 'vue';

    const props = defineProps({
        event: Object,
    });

    const showModal = ref(false);
    const canApply = ref(true);

    onMounted(() => {
        axios.get('https://api.aeroweb.ca/v1/camaq/user-country').then(response => {
            // We can only apply from Canada or the US
            if (response.data.country != 'Canada' && response.data.country != 'France' && response.data.country != 'United States') {
                canApply.value = false;
            }
        });

        if (window.location.hash === '#inscription') {
            show();
        }
    });

    function show() {
        showModal.value = true;
        window.location.hash = 'inscription';
    }

    function hide() {
        showModal.value = false;
        window.location.hash = '';
    }

    function onSuccess() {
        hide();

        setTimeout(() => {
            Swal.fire({
                title: 'Succès',
                text: trans('You have successfully signed up for the event :title!', { title: props.event?.title }),
                icon: 'success',
                timer: 3000,
                timerProgressBar: true,
                showConfirmButton: false,
            });

            if (props.event?.redirection_url?.length) {
                setTimeout(() => {
                    window.location.href = props.event?.redirection_url;
                }, 2000);
            }
        }, 500);
    }

    defineExpose({ show });
</script>
